export default "__VITE_ASSET__mc3dYs9h__"